<template>
  <div class="ma-0 pa-0 overlayContainer">
    <v-card class="overlayElement" width="350" min-height="350" rounded="lg">
      <v-card-title
        class="justify-center"
        style="font-family: Nunito Sans; font-weight: 900"
        >augmentable</v-card-title
      >
      <v-form ref="form" class="pa-10">
        <v-text-field
          v-on:keyup.enter="userConfirmPassword()"
          class="pb-0"
          v-model="password1"
          outlined
          dense
          rounded="lg"
          label="Password"
          :append-icon="showEye ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="showEye = !showEye"
          :type="showEye ? 'text' : 'password'"
          :rules="[rules.required, rules.minPass, rules.maxPass]"
        ></v-text-field>
        <v-text-field
          v-on:keyup.enter="userConfirmPassword()"
          class="pb-0"
          v-model="password2"
          outlined
          dense
          rounded="lg"
          label="Confirm Password"
          :append-icon="showEye ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="showEye = !showEye"
          :type="showEye ? 'text' : 'password'"
          :rules="[rules.required, rules.minPass, rules.maxPass]"
        ></v-text-field>
        <p class="mt-n2 ml-2" style="color: red; text-align: left" v-if="error">
          {{ errorMsg }}
        </p>
        <v-row align="center" justify="center">
          <v-col cols="6"> </v-col>

          <v-col cols="4">
            <v-btn @click="userConfirmPassword()" size="10"> Verify </v-btn>
          </v-col>
          <v-col cols="2"></v-col>
        </v-row>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";

axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
axios.defaults.xsrfCookieName = "csrftoken";

export default {
  name: "passwordReset",
  components: {},
  data: function () {
    return {
      uid: this.$route.params.uid,
      token: this.$route.params.token,
      password1: "",
      password2: "",
      rules: {
        required: (value) => !!value || "Required.",
        minPass: (v) => v.length >= 8 || "Min 8 characters",
        maxPass: (v) => v.length <= 30 || "Max 30 characters",
        minName: (v) => v.length >= 3 || "Min 3 characters",
        maxName: (v) => v.length <= 30 || "Max 30 characters",
        emailMatch: () => "The email and password you entered don't match",
        email: (value) => {
          if (value.length > 0) {
            const pattern =
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return pattern.test(value) || "Invalid e-mail.";
          }
        },
      },
      showEye: false,
      error: false,
      errorMsg: "",
    };
  },

  mounted() {
    // console.log(this.uid);
    // console.log(this.token);
  },
  methods: {
    userConfirmPassword() {
      if (!this.password1) {
        this.error = true;
        this.errorMsg = "*All fileds are required!";
        return;
      }
      if (!this.password2) {
        this.error = true;
        this.errorMsg = "*All fileds are required!";
        return;
      }
      if (this.password1 != this.password2) {
        this.error = true;
        this.errorMsg = "*Passwords are not matching";
        return;
      }

      let formData = new FormData();
      formData.append("uid", this.uid);
      formData.append("token", this.token);
      formData.append("new_password1", this.password1);
      formData.append("new_password2", this.password2);

      axios
        .post("/dj-rest-auth/password/reset/confirm/", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          alert(response.data.detail);
          console.log("SUCCESS!!");
          this.$router.push({ path: "/" });
        })
        .catch((error) => {
          if (error.response.status === 400) {
            if (error.response.data) {
              if (error.response.data.new_password1) {
                this.error = true;
                this.errorMsg = error.response.data.new_password1[0];
              }
              if (error.response.data.new_password2) {
                this.error = true;
                this.errorMsg = error.response.data.new_password2[0];
              }
              if (error.response.data.token) {
                this.error = true;
                this.errorMsg = "Link is invalid or it's expired";
              }
              if (error.response.data.uid) {
                this.error = true;
                this.errorMsg = "Link is invalid or it's expired";
              }
              //console.log(error.response.data);
            }
          }

          // this.$router.push({ path: "/" });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css?family=Nunito Sans:200,300,400,600,700,800,900");

.overlayContainer {
  position: absolute;
  width: 100%;
  height: 100%;
  display: block;
  overflow-y: hidden;
  top: 0;
  left: 0;
  background-color: rgba(black, 0.5);
  z-index: 90000;
}
.overlayElement {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}
</style>